import React, { useCallback, useState, useRef } from 'react'
import Loader from '../../components/Loader/Loader'
import 'ag-grid-enterprise'
import './TradeBlotter.css'
import {
  ContainerBloomberg,
  ContainerRatesWidget,
  ContainerTradeBlotterWidget,
  PaperStyle,
  TypographyStyle
} from './TradeBlotter.style'
import { TradeBlotterFilter } from './classes/TradeBlotterFilter.js'
import { webSocketWorkerEvent } from '../../services'
import { Grid } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { handelNotifications } from '../../redux/slices/Notification/notificationSlice'
import { routes, SIGN } from '../../utils/constants'
import { checkSomeLoader, cleanEmptyField, getCountryTimezoneUtc } from '../../helper/index'
import BloombergConnection from './components/BloombergConnection/BloombergConnection.js'
import greenPulse from './data/pulse.json'
import orangePulse from './data/pulse_orange.json'
import useTradeBlotterAgGridSetting from './hooks/AgGrid.setting.js'
import useToolBarSetting from './hooks/toolBar.setting.js'
import useBloombergSetting from './hooks/bloomberg.setting.js'
import useAgGridColumnSetting from './hooks/AgGridColumn.setting.js'
import WidgetTradeBlotter from './components/WidgetTradeBlotter/WidgetTradeBlotter.js'
import WidgetRates from './components/WidgetRates/WidgetRates.js'
import WidgetActivityBlotter from './components/WidgetActivityBlotter/WidgetActivityBlotter.js'
import useAgGridPriceSettings from './hooks/AgGridPrice.settings.js'
import { defaultLayout } from './data/layout.js'
import { setWidgets } from '../../redux/slices/widgets/WidgetsSlice.js'
import axios from 'axios'
import useTradeBlotterRequestHandler from './hooks/tradeBlotter.request.handler.js'
import TradeBlotterToolBar from './components/TradeBlotterTollbar/TradeBlotterToolBar.js'
import useAgGridActivityBlotter from './hooks/AgGridActivityBlotter.setting.js'
import useAxios from '../../hooks/useAxios.js'
import useToolBarSettingDisabled from './hooks/toolBar.setting.disabled.js'
import WidgetsLoader from './components/WidgetsLoader/WidgetsLoader.js'

const TradeBlotter = () => {
  const getWidgets = async () => {
    try {
      const url = process.env.REACT_APP_SERVER_URL.concat(routes.getWidget, '/')
      const result = await axios.get(url, {
        headers: { Authorization: token }
      })
      result.data = result.data.map(widget => widget.preferences)
      if (result.data.includes('Activity Blotter')) {
        webSocketWorkerEvent.sendEvent({
          type: 'get_activity_blotter',
          data: {
            country_timezone_utc: getCountryTimezoneUtc()
          }
        })
      }
      dispatch(setWidgets(result.data))
    } catch (error) {
      console.log(error)
    }
  }

  const dispatchNotification = (message, type) => {
    dispatch(
      handelNotifications({
        id: Date.now(),
        type,
        message
      })
    )
  }
  const [bloombergRefresh, setBloombergRefresh] = useState(1)
  const lastOrderColumnSort = useRef({ order: '', column_order: '' })
  const [priceRatesData, setPriceRatesData] = useState([])
  const [bloombergConnection, setBloombergConnection] = useState(false)
  const [, setMenuPriceLoading] = useState(true)
  const [dealTradesGroup, setDealTradesGroup] = useState({})
  const [tradesGroup, setTradesGroup] = useState({})
  const [dealsGroup, setDealsGroup] = useState({})
  const [dealsNotSentToPb, setDealsNotSentToPb] = useState({})
  const [tradesGiveUp, setTradesGiveUp] = useState({})
  const [tradesConversion, setTradesConversion] = useState({})
  const [unAllocatedDeals, setUnAllocatedDeals] = useState({})
  const [dealsGiveUpGroup, setDealsGiveUpGroup] = useState({})
  const gridRef = useRef(null)
  const gridScrollHight = useRef({ top: 0 })
  const [page, setPage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [disabled, setDisabled] = useState({ next: false, prev: true })
  const [pagination, setPagination] = useState([{}])
  const [filters, setFilters] = useState(new TradeBlotterFilter())
  const [loading, setLoading] = useState(true)
  const [tradeBlotterResponse, setTradeBlotterResponse] = useState({ status: '', data: [] })
  const [selected, setSelected] = useState(0)
  const [selectedAllDeal, setSelectedAllDeal] = useState({
    status: false,
    maxDeals: 0,
    signDeals: 0
  })
  const [priceRatesNormalize, setPriceRatesNormalize] = useState({})
  const [checkBoxHeader, setCheckBoxHeader] = useState(false)
  const [openPrice, setOpenPrice] = useState(false)
  const [review, setReview] = useState(0)
  const [lock, setLock] = useState(false)
  const token = useSelector(state => state.auth.token)
  const entitlements = useSelector(state => state.auth.entitlements)
  const dispatch = useDispatch()

  const [lastSearch, setLastSearch] = useState('')
  const tradeBlotterDataAgGrid = useRef()
  const bloombergPriceSnapshot = useSelector(state => state.bloomberg.data)
  const widgets = useSelector(state => state.widgets.widgets)
  const [expandsRow, setExpandsRow] = useState(0)
  const request1 = { endPoint: routes.tradeSymbol }
  const request2 = { endPoint: routes.dealTypes }
  const request3 = { endPoint: routes.tradeCounterparty }
  const request4 = { endPoint: routes.makorPrimeBroker }
  const request5 = { endPoint: routes.tradeOrigin }
  const request6 = { endPoint: routes.fixingSource }
  const request7 = { endPoint: routes.currency }
  const request8 = { endPoint: routes.timing }
  const request9 = { endPoint: routes.optionStyle }
  const request10 = { endPoint: routes.barrierDirection }
  const request11 = { endPoint: routes.trader }

  const { response: tradeSymbolData, loader: loaderTradeSymbol } = useAxios(request1)
  const { response: dealTypeData, loader: loaderDealType } = useAxios(request2)
  const { response: tradeCounterpartyData, loader: loaderCounterParty } = useAxios(request3)
  const { response: makorPrimeBrokerData, loader: loaderPrimeBroker } = useAxios(request4)
  const { response: tradeOriginData, loader: tradeOriginLoader } = useAxios(request5)
  const { response: fixingSourceData, loader: fixingSourceLoader } = useAxios(request6)
  const { response: currencyData, loader: currencyLoader } = useAxios(request7)
  const { response: timingData, loader: timingLoader } = useAxios(request8)
  const { response: optionStyleData, loader: optionStyleLoader } = useAxios(request9)
  const { response: barrierDirectionData, loader: barrierDirectionLoader } = useAxios(request10)
  const { response: traderData, loader: traderLoader } = useAxios(request11)

  let loaderFirstTime = useRef(true).current

  const loaderList = [
    loaderTradeSymbol,
    loaderDealType,
    loaderCounterParty,
    loaderPrimeBroker,
    tradeOriginLoader,
    fixingSourceLoader,
    currencyLoader,
    timingLoader,
    optionStyleLoader,
    barrierDirectionLoader,
    traderLoader
  ]

  const { defaultColDef2, columnsDefs2, getRowId2 } = useAgGridPriceSettings({
    setOpenPrice,
    openPrice,
    defaultLayout
  })
  const tradeBlotterPendingAgGrid = useRef([])

  const {
    onRowClicked,
    onBodyScroll,
    onFilterChanged,
    getRows,
    getRowId,
    getContextMenuItems,
    getRowStyle,
    onRowDoubleClicked,
    onRowGroupOpened,
    onColumnMoved,
    onGridReady,
    isServerSideGroup,
    getServerSideGroupKey,
    onFirstDataRendered,
    onColumnResized,
    skeltonLoader,
    onSortChange
  } = useTradeBlotterAgGridSetting({
    selected,
    setSelected,
    gridRef,
    expandsRow,
    dealTradesGroup,
    tradesConversion,
    setTradesConversion,
    setDealTradesGroup,
    cleanCheckBoxState,
    dealsGiveUpGroup,
    setDealsGiveUpGroup,
    tradesGroup,
    setTradesGroup,
    dealsGroup,
    setDealsGroup,
    dealsNotSentToPb,
    tradeBlotterPendingAgGrid,
    setDealsNotSentToPb,
    tradesGiveUp,
    setTradesGiveUp,
    unAllocatedDeals,
    setUnAllocatedDeals,
    setBloombergRefresh,
    bloombergRefresh,
    dispatch,
    token,
    filters,
    setExpandsRow,
    setFilters,
    setPage,
    tradeBlotterResponse,
    gridScrollHight,
    setTradeBlotterResponse,
    selectedAllDeal,
    setSelectedAllDeal,
    checkBoxHeader,
    setCheckBoxHeader,
    tradeSymbolData,
    dealTypeData,
    tradeCounterpartyData,
    makorPrimeBrokerData,
    tradeOriginData,
    fixingSourceData,
    currencyData,
    timingData,
    optionStyleData,
    tradeBlotterDataAgGrid,
    lastOrderColumnSort,
    lock,
    setLock
  })

  const {
    columnsDefs: columnsDefsActivityBlotter,
    defaultColDef: defaultColDefActivityBlotter,
    onRowClicked: onRowClickedActivityBlotter,
    activityBlotterResponse
  } = useAgGridActivityBlotter({ priceRatesNormalize, skeltonLoader, filters, setFilters, widgets })

  useTradeBlotterRequestHandler({
    gridScrollHight,
    tradeBlotterResponse,
    filters,
    selected,
    disabled,
    page,
    tradesGroup,
    dealsGroup,
    tradesGiveUp,
    unAllocatedDeals,
    bloombergRefresh,
    setBloombergRefresh,
    setTradesGiveUp,
    getRows,
    setLock,
    skeltonLoader,
    review,
    gridRef,
    expandsRow,
    pagination,
    tradeBlotterPendingAgGrid,
    setTradeBlotterResponse,
    setLoading,
    setDisabled,
    tradesConversion,
    setTradesConversion,
    dealTradesGroup,
    setReview,
    getWidgets,
    setPagination,
    setDealsGroup,
    setTradesGroup,
    setDealsGiveUpGroup,
    setDealTradesGroup,
    setSelected,
    setDealsNotSentToPb,
    selectedAllDeal,
    setSelectedAllDeal,
    dispatchNotification,
    setUnAllocatedDeals,
    tradeBlotterDataAgGrid,
    priceRatesNormalize,
    totalPage,
    setTotalPage
  })

  const {
    csvExport,
    handelTradeDealDelete,
    handelGroupButtonRender,
    handelDealTradeGiveUp,
    handelUnGroupDeals,
    handelAmendTrade,
    handelGroupTrade,
    handelUnAllocateDeal,
    handelDeleteTradingAccountShortnameFilter,
    cleanFilters
  } = useToolBarSetting({
    gridRef,
    dealsGroup,
    tradesGroup,
    tradesGiveUp,
    tradesConversion,
    dealsNotSentToPb,
    dealsGiveUpGroup,
    dealTradesGroup,
    unAllocatedDeals,
    tradeBlotterDataAgGrid,
    dispatchNotification,
    cleanCheckBoxState,
    setPage,
    filters,
    setFilters,
    skeltonLoader,
    initialFilterState: new TradeBlotterFilter()
  })

  useBloombergSetting({
    gridRef,
    priceRatesNormalize,
    bloombergRefresh,
    setPriceRatesNormalize,
    tradeBlotterResponse,
    tradeBlotterDataAgGrid,
    priceRatesData,
    setPriceRatesData,
    setMenuPriceLoading,
    setBloombergConnection,
    bloombergPriceSnapshot
  })

  const { columnsDefs, defaultColDef, autoGroupColumnDef } = useAgGridColumnSetting({
    tradesGroup,
    dealsGroup,
    dealTradesGroup,
    tradesGiveUp,
    tradesConversion,
    tradeBlotterResponse,
    setSelected,
    dealsGiveUpGroup,
    setSelectedAllDeal,
    checkBoxHeader,
    setCheckBoxHeader,
    setDealsGiveUpGroup,
    setDealsGroup,
    selectedAllDeal,
    selected,
    cleanCheckBoxState,
    filters,
    dealTypeData,
    traderData,
    tradeCounterpartyData,
    tradeSymbolData,
    currencyData,
    fixingSourceData,
    timingData,
    makorPrimeBrokerData,
    tradeOriginData,
    barrierDirectionData
  })

  const {
    disabledGroupTrade,
    disabledUnGroupDeal,
    disabledAmendTrade,
    disabledDealGiveUp,
    disabledDeleteTradeDeal,
    disabledUnAllocatedDeal
  } = useToolBarSettingDisabled({
    dealsGroup,
    tradesGroup,
    dealsNotSentToPb,
    dealTradesGroup,
    tradesGiveUp,
    tradesConversion,
    dealsGiveUpGroup,
    unAllocatedDeals
  })

  const isUserBooking = () => entitlements.includes('Booking')

  const handelBlotterLoader = () => {
    const dataSource = { getRows }
    tradeBlotterDataAgGrid.current = [{ isSkelton: true }]
    gridRef.current.api.setServerSideDatasource(dataSource)
  }

  const handelGlobalFilterIcon = async name => {
    const copyFilters1 = JSON.parse(JSON.stringify(filters))
    const copyFilters2 = JSON.parse(JSON.stringify(filters))
    if (name === 'status_warning_and_union') {
      copyFilters1.status_warning_and_union = !copyFilters1.status_warning_and_union
      copyFilters2.status_warning_and_union = !copyFilters2.status_warning_and_union
    }
    setFilters(copyFilters1)
    cleanCheckBoxState()
    cleanEmptyField(copyFilters2)
    cleanPaginationFilter()
    handelBlotterLoader()
    delete copyFilters2.trade_date_start_look_for
    delete copyFilters2.trade_date_end_look_for
    webSocketWorkerEvent.sendEvent({ type: 'get_trade_blotter', data: copyFilters2 })
  }

  const handelStatusFilterChange = event => {
    let { name, checked } = event.target
    name = name.toLowerCase()
    const copyFilters = JSON.parse(JSON.stringify(filters))
    copyFilters.deal_status[name] = checked
    setFilters(copyFilters)
    cleanEmptyField(copyFilters)
    handelBlotterLoader()
    webSocketWorkerEvent.sendEvent({ type: 'get_trade_blotter', data: copyFilters })
  }

  const handelGlobalSearchFilter = event => {
    const { value } = event.target
    setFilters(filters => ({ ...filters, search: value }))
    if (value === '') {
      handelServerCallSearchBar(value)
    }
  }

  const handelServerCallSearchBar = value => {
    const copyFilters = JSON.parse(JSON.stringify(filters))
    cleanCheckBoxState()
    cleanEmptyField(copyFilters)
    cleanPaginationFilter(copyFilters)
    handelBlotterLoader()
    if (typeof value === 'string') {
      copyFilters.search = ''
    }
    if (lastSearch !== copyFilters.search) {
      delete copyFilters.trade_date_start_look_for
      delete copyFilters.trade_date_end_look_for
      webSocketWorkerEvent.sendEvent({ type: 'get_trade_blotter', data: copyFilters })
    }
  }

  const handelKeyPress = event => {
    if (event.code === 'Enter') {
      setLastSearch(filters.search)
      handelServerCallSearchBar()
    }
  }

  function cleanCheckBoxState(pagination = true) {
    const groups = [
      [tradesGroup, setTradesGroup],
      [dealTradesGroup, setDealTradesGroup],
      [dealsGroup, setDealsGroup],
      [dealsGiveUpGroup, setDealsGiveUpGroup],
      [tradesGiveUp, setTradesGiveUp],
      [tradesConversion, setTradesConversion],
      [unAllocatedDeals, setUnAllocatedDeals],
      [dealsNotSentToPb, setDealsNotSentToPb]
    ]

    groups.forEach(([group, setter]) => {
      if (Object.keys(group).length !== 0) {
        setter(() => ({}))
      }
    })

    if (pagination && page !== 1) {
      setPage(1)
    }

    if (selected !== 0) {
      setSelected(0)
    }

    if (selectedAllDeal.status || selectedAllDeal.signDeals > 0) {
      setSelectedAllDeal({ ...selectedAllDeal, status: false, signDeals: 0 })
    }

    if (checkBoxHeader) {
      setCheckBoxHeader(false)
    }

    if (lastSearch) {
      setLastSearch('')
    }
  }

  const cleanPaginationFilter = useCallback(() => {
    setPage(() => 1)
    setDisabled(() => ({ prev: true, next: false }))
  }, [])

  const handelPagination = sign => {
    const paginationCall = sign === SIGN.NEXT ? pagination[page] : pagination[page - 2]
    const newPage = sign === SIGN.NEXT ? page + 1 : page - 1
    const copyFilters = JSON.parse(JSON.stringify(filters))
    setDisabled({ prev: true, next: true })

    setPage(newPage)
    if (newPage === totalPage) {
      copyFilters.come_to_last_page = true
      copyFilters.total_page = totalPage
    }
    let data = {
      ...copyFilters,
      ...paginationCall
    }
    cleanEmptyField(data)
    cleanCheckBoxState(false)
    handelBlotterLoader()
    const request = {
      type: 'get_trade_blotter',
      data: data
    }
    webSocketWorkerEvent.sendEvent(request)
  }

  const removeWidgetToUserPreference = async val => {
    try {
      const url = process.env.REACT_APP_SERVER_URL.concat(routes.removeWidget, '/')
      const result = await axios.post(
        url,
        { val },
        {
          headers: { Authorization: token }
        }
      )
      if (val === 'Activity Blotter') {
        webSocketWorkerEvent.sendEvent({ type: 'remove_activity_blotter', data: {} })
      }
      dispatch(setWidgets(result.data))
    } catch (error) {
      console.log(error)
    }
  }

  const handleRemoveWidget = async val => {
    switch (val) {
      case 'Rates':
        removeWidgetToUserPreference('Rates')
        break
      case 'Activity Blotter':
        removeWidgetToUserPreference('Activity Blotter')
        break
    }
  }

  const findWidgetPreferences = () => {
    const preferences = {}
    if (Array.isArray(widgets)) {
      preferences.tradeBlotter = true
      preferences.activityBlotter = widgets.find(widget => widget === 'Activity Blotter')
      preferences.rates = widgets.find(widget => widget === 'Rates')
    }
    return preferences
  }

  const widgetHandler = () => {
    const preferences = findWidgetPreferences()

    if (Array.isArray(widgets) && widgets.length === 0) {
      if (preferences.tradeBlotter && !preferences.activityBlotter && !preferences.rates) {
        return (
          <PaperStyle>
            <WidgetTradeBlotter
              handelPagination={handelPagination}
              handleRemoveWidget={handleRemoveWidget}
              gridRef={gridRef}
              columnsDefs={columnsDefs}
              defaultColDef={defaultColDef}
              getRowStyle={getRowStyle}
              getRowId={getRowId}
              onFilterChanged={onFilterChanged}
              onBodyScroll={onBodyScroll}
              onRowClicked={onRowClicked}
              onSortChange={onSortChange}
              onGridReady={onGridReady}
              onFirstDataRendered={onFirstDataRendered}
              onColumnMoved={onColumnMoved}
              onRowGroupOpened={onRowGroupOpened}
              onRowDoubleClicked={onRowDoubleClicked}
              onColumnResized={onColumnResized}
              getContextMenuItems={getContextMenuItems}
              isServerSideGroup={isServerSideGroup}
              getServerSideGroupKey={getServerSideGroupKey}
              autoGroupColumnDef={autoGroupColumnDef}
              page={page}
              disabled={disabled}
            >
              <TradeBlotterToolBar
                isUserBooking={isUserBooking}
                csvExport={csvExport}
                handelUnAllocateDeal={handelUnAllocateDeal}
                disabledUnAllocatedDeal={disabledUnAllocatedDeal}
                handelGroupButtonRender={handelGroupButtonRender}
                handelGroupTrade={handelGroupTrade}
                disabledGroupTrade={disabledGroupTrade}
                handelUnGroupDeals={handelUnGroupDeals}
                disabledUnGroupDeal={disabledUnGroupDeal}
                handelAmendTrade={handelAmendTrade}
                handelKeyPress={handelKeyPress}
                handelDeleteTradingAccountShortnameFilter={
                  handelDeleteTradingAccountShortnameFilter
                }
                disabledAmendTrade={disabledAmendTrade}
                handelDealTradeGiveUp={handelDealTradeGiveUp}
                disabledDealGiveUp={disabledDealGiveUp}
                handelTradeDealDelete={handelTradeDealDelete}
                disabledDeleteTradeDeal={disabledDeleteTradeDeal}
                cleanFilters={cleanFilters}
                filters={filters}
                setFilters={setFilters}
                handelGlobalFilterIcon={handelGlobalFilterIcon}
                handelStatusFilterChange={handelStatusFilterChange}
                page={page}
                review={review}
                setPage={setPage}
                cleanCheckBoxState={cleanCheckBoxState}
                handelGlobalSearchFilter={handelGlobalSearchFilter}
              />
            </WidgetTradeBlotter>
          </PaperStyle>
        )
      }
    }

    if (preferences.tradeBlotter && preferences.activityBlotter && !preferences.rates) {
      return (
        <PaperStyle>
          <Grid container spacing={2} height={'100%'} display={'flex'}>
            <ContainerTradeBlotterWidget item xs={12}>
              <WidgetActivityBlotter
                filters={filters}
                onRowClicked={onRowClickedActivityBlotter}
                handleRemoveWidget={handleRemoveWidget}
                columnDefs={columnsDefsActivityBlotter}
                defaultColDef={defaultColDefActivityBlotter}
                activityBlotterResponse={activityBlotterResponse}
              />
              <WidgetTradeBlotter
                style={{ marginTop: '10px' }}
                handelPagination={handelPagination}
                handleRemoveWidget={handleRemoveWidget}
                gridRef={gridRef}
                columnsDefs={columnsDefs}
                defaultColDef={defaultColDef}
                onFilterChanged={onFilterChanged}
                onRowGroupOpened={onRowGroupOpened}
                onSortChange={onSortChange}
                onGridReady={onGridReady}
                onRowDoubleClicked={onRowDoubleClicked}
                onFirstDataRendered={onFirstDataRendered}
                onColumnResized={onColumnResized}
                getRowStyle={getRowStyle}
                getRowId={getRowId}
                onBodyScroll={onBodyScroll}
                onColumnMoved={onColumnMoved}
                onRowClicked={onRowClicked}
                getContextMenuItems={getContextMenuItems}
                isServerSideGroup={isServerSideGroup}
                getServerSideGroupKey={getServerSideGroupKey}
                autoGroupColumnDef={autoGroupColumnDef}
                page={page}
                disabled={disabled}
              >
                <TradeBlotterToolBar
                  isUserBooking={isUserBooking}
                  csvExport={csvExport}
                  handelUnAllocateDeal={handelUnAllocateDeal}
                  disabledUnAllocatedDeal={disabledUnAllocatedDeal}
                  handelGroupButtonRender={handelGroupButtonRender}
                  handelKeyPress={handelKeyPress}
                  handelGroupTrade={handelGroupTrade}
                  disabledGroupTrade={disabledGroupTrade}
                  handelUnGroupDeals={handelUnGroupDeals}
                  disabledUnGroupDeal={disabledUnGroupDeal}
                  handelAmendTrade={handelAmendTrade}
                  handelDeleteTradingAccountShortnameFilter={
                    handelDeleteTradingAccountShortnameFilter
                  }
                  disabledAmendTrade={disabledAmendTrade}
                  handelDealTradeGiveUp={handelDealTradeGiveUp}
                  disabledDealGiveUp={disabledDealGiveUp}
                  handelTradeDealDelete={handelTradeDealDelete}
                  disabledDeleteTradeDeal={disabledDeleteTradeDeal}
                  cleanFilters={cleanFilters}
                  filters={filters}
                  setFilters={setFilters}
                  handelGlobalFilterIcon={handelGlobalFilterIcon}
                  handelStatusFilterChange={handelStatusFilterChange}
                  page={page}
                  setPage={setPage}
                  review={review}
                  cleanCheckBoxState={cleanCheckBoxState}
                  handelGlobalSearchFilter={handelGlobalSearchFilter}
                />
              </WidgetTradeBlotter>
            </ContainerTradeBlotterWidget>
          </Grid>
        </PaperStyle>
      )
    }

    if (preferences.tradeBlotter && preferences.rates && !preferences.activityBlotter) {
      return (
        <PaperStyle>
          <Grid container spacing={2} height={'100%'} display={'flex'}>
            <ContainerTradeBlotterWidget item xl={9.6} lg={9} md={8} sm={12} xs={12}>
              <WidgetTradeBlotter
                handelPagination={handelPagination}
                handleRemoveWidget={handleRemoveWidget}
                gridRef={gridRef}
                columnsDefs={columnsDefs}
                defaultColDef={defaultColDef}
                getRowStyle={getRowStyle}
                getRowId={getRowId}
                onSortChange={onSortChange}
                onFilterChanged={onFilterChanged}
                onBodyScroll={onBodyScroll}
                onColumnMoved={onColumnMoved}
                onColumnResized={onColumnResized}
                onRowClicked={onRowClicked}
                onRowDoubleClicked={onRowDoubleClicked}
                onGridReady={onGridReady}
                onFirstDataRendered={onFirstDataRendered}
                onRowGroupOpened={onRowGroupOpened}
                getContextMenuItems={getContextMenuItems}
                isServerSideGroup={isServerSideGroup}
                getServerSideGroupKey={getServerSideGroupKey}
                autoGroupColumnDef={autoGroupColumnDef}
                page={page}
                disabled={disabled}
              >
                <TradeBlotterToolBar
                  isUserBooking={isUserBooking}
                  csvExport={csvExport}
                  handelUnAllocateDeal={handelUnAllocateDeal}
                  disabledUnAllocatedDeal={disabledUnAllocatedDeal}
                  handelGroupButtonRender={handelGroupButtonRender}
                  handelGroupTrade={handelGroupTrade}
                  disabledGroupTrade={disabledGroupTrade}
                  handelUnGroupDeals={handelUnGroupDeals}
                  disabledUnGroupDeal={disabledUnGroupDeal}
                  handelAmendTrade={handelAmendTrade}
                  handelKeyPress={handelKeyPress}
                  handelDeleteTradingAccountShortnameFilter={
                    handelDeleteTradingAccountShortnameFilter
                  }
                  disabledAmendTrade={disabledAmendTrade}
                  handelDealTradeGiveUp={handelDealTradeGiveUp}
                  disabledDealGiveUp={disabledDealGiveUp}
                  handelTradeDealDelete={handelTradeDealDelete}
                  disabledDeleteTradeDeal={disabledDeleteTradeDeal}
                  cleanFilters={cleanFilters}
                  filters={filters}
                  setFilters={setFilters}
                  handelGlobalFilterIcon={handelGlobalFilterIcon}
                  handelStatusFilterChange={handelStatusFilterChange}
                  page={page}
                  setPage={setPage}
                  review={review}
                  cleanCheckBoxState={cleanCheckBoxState}
                  handelGlobalSearchFilter={handelGlobalSearchFilter}
                />
              </WidgetTradeBlotter>
            </ContainerTradeBlotterWidget>
            <ContainerRatesWidget item xl={2.4} lg={3} md={4} sm={12} xs={12}>
              <WidgetRates
                handleRemoveWidget={handleRemoveWidget}
                columnsDefs2={columnsDefs2}
                data={priceRatesData}
                getRowId2={getRowId2}
                defaultColDef2={defaultColDef2}
              />
            </ContainerRatesWidget>
          </Grid>
        </PaperStyle>
      )
    }

    if (preferences.tradeBlotter && preferences.rates && preferences.activityBlotter) {
      return (
        <PaperStyle>
          <Grid container spacing={2} height={'100%'} display={'flex'}>
            <ContainerTradeBlotterWidget item xl={9.6} lg={9} md={8} sm={12} xs={12}>
              <WidgetActivityBlotter
                filters={filters}
                onRowClicked={onRowClickedActivityBlotter}
                handleRemoveWidget={handleRemoveWidget}
                columnDefs={columnsDefsActivityBlotter}
                defaultColDef={defaultColDefActivityBlotter}
                activityBlotterResponse={activityBlotterResponse}
              />
              <WidgetTradeBlotter
                style={{ marginTop: '10px' }}
                handelPagination={handelPagination}
                handleRemoveWidget={handleRemoveWidget}
                gridRef={gridRef}
                columnsDefs={columnsDefs}
                defaultColDef={defaultColDef}
                onRowGroupOpened={onRowGroupOpened}
                onColumnMoved={onColumnMoved}
                onColumnResized={onColumnResized}
                getRowStyle={getRowStyle}
                onFilterChanged={onFilterChanged}
                onGridReady={onGridReady}
                onRowDoubleClicked={onRowDoubleClicked}
                onFirstDataRendered={onFirstDataRendered}
                tradeBlotterResponse={tradeBlotterResponse}
                getRowId={getRowId}
                onBodyScroll={onBodyScroll}
                onRowClicked={onRowClicked}
                getContextMenuItems={getContextMenuItems}
                isServerSideGroup={isServerSideGroup}
                getServerSideGroupKey={getServerSideGroupKey}
                autoGroupColumnDef={autoGroupColumnDef}
                page={page}
                disabled={disabled}
              >
                <TradeBlotterToolBar
                  isUserBooking={isUserBooking}
                  csvExport={csvExport}
                  handelUnAllocateDeal={handelUnAllocateDeal}
                  disabledUnAllocatedDeal={disabledUnAllocatedDeal}
                  handelGroupButtonRender={handelGroupButtonRender}
                  handelKeyPress={handelKeyPress}
                  handelGroupTrade={handelGroupTrade}
                  disabledGroupTrade={disabledGroupTrade}
                  handelUnGroupDeals={handelUnGroupDeals}
                  disabledUnGroupDeal={disabledUnGroupDeal}
                  handelAmendTrade={handelAmendTrade}
                  handelDeleteTradingAccountShortnameFilter={
                    handelDeleteTradingAccountShortnameFilter
                  }
                  disabledAmendTrade={disabledAmendTrade}
                  handelDealTradeGiveUp={handelDealTradeGiveUp}
                  disabledDealGiveUp={disabledDealGiveUp}
                  handelTradeDealDelete={handelTradeDealDelete}
                  disabledDeleteTradeDeal={disabledDeleteTradeDeal}
                  cleanFilters={cleanFilters}
                  filters={filters}
                  setFilters={setFilters}
                  handelGlobalFilterIcon={handelGlobalFilterIcon}
                  handelStatusFilterChange={handelStatusFilterChange}
                  page={page}
                  setPage={setPage}
                  review={review}
                  cleanCheckBoxState={cleanCheckBoxState}
                  handelGlobalSearchFilter={handelGlobalSearchFilter}
                />
              </WidgetTradeBlotter>
            </ContainerTradeBlotterWidget>
            <ContainerRatesWidget item xl={2.4} lg={3} md={4} sm={12} xs={12}>
              <WidgetRates
                handleRemoveWidget={handleRemoveWidget}
                columnsDefs2={columnsDefs2}
                data={priceRatesData}
                getRowId2={getRowId2}
                defaultColDef2={defaultColDef2}
              />
            </ContainerRatesWidget>
          </Grid>
        </PaperStyle>
      )
    }
  }

  if (loading && checkSomeLoader(loaderList) && loaderFirstTime) {
    loaderFirstTime = false
    return <Loader />
  }

  return (
    <PaperStyle className={'ag-theme-quartz-dark'}>
      {loading && tradeBlotterResponse.status !== 'ok' && (
        <WidgetsLoader preferences={findWidgetPreferences()} />
      )}
      {!loading && tradeBlotterResponse.status === 'ok' && widgetHandler()}
      {!loading && (
        <ContainerBloomberg>
          {!bloombergConnection ? <TypographyStyle>Using indicative rates</TypographyStyle> : null}
          <BloombergConnection
            animationData={bloombergConnection ? greenPulse : orangePulse}
            bloombergConnection={bloombergConnection}
          />
        </ContainerBloomberg>
      )}
    </PaperStyle>
  )
}

export default TradeBlotter
